import type { Evidence_EvidenceSetFragment } from "~/features/dataImportProjects/gqls/fragment/evidence-evidenceSet.generated";
import type { FlattenedDraft } from "~/features/dataImportProjects/types";
import { ObjectUtils } from "~/utils/object";

export function flattenEvidence(evidence: Evidence_EvidenceSetFragment): FlattenedDraft {
  const flattened = ObjectUtils.flattenKeys(
    { properties: evidence.properties, metadata: evidence.metadata },
    { targetKeys: ["properties", "metadata"], delimiter: "/" },
  );

  return Object.entries(flattened).reduce<FlattenedDraft>(
    (acc, [key, value]) => {
      acc[key] = typeof value === "object" && value !== null ? JSON.stringify(value) : String(value ?? "");
      return acc;
    },
    { evidenceId: evidence.id },
  );
}
